import React, { useRef, useState } from 'react';
import { IonButton, IonModal, IonContent, IonList, IonItem, IonLabel, IonAvatar, IonImg, IonSearchbar, IonHeader, IonToolbar, IonTitle, IonButtons, IonIcon, IonTextarea } from '@ionic/react';
import { close } from 'ionicons/icons'

function NewRole({ open, onClose, predefinedRoles, onAddRole }) {
  const [suggestedRoles, setSuggestedRoles] = useState<string[]>(predefinedRoles)

  return (
    <>
        <IonModal isOpen={open} onDidDismiss={onClose}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Role picker</IonTitle>
              <IonButtons slot="end">
                <IonButton strong={true} onClick={onClose}>
                  <IonIcon icon={close} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonSearchbar placeholder="Search roles" debounce={100}
            onIonInput={e => {
              const search = e.detail.value || '';
              setSuggestedRoles(() => {
                return predefinedRoles.filter(role =>
                  role.toLowerCase().startsWith(search.toLowerCase())
                );
              })}}
          ></IonSearchbar>

          {suggestedRoles.length > 0 && (<IonList>
            {suggestedRoles.map((result) => (
              <IonItem key={result} button={true} onClick={() => onAddRole(result)}>{result}</IonItem>
            ))}
          </IonList>)}
          {suggestedRoles.length == 0 && (<>
            <p>Role not found. Create new role?</p>
            <IonTextarea label='Prompt' labelPlacement='stacked' rows={17} fill='solid' placeholder='Describe how to play this role'></IonTextarea>
            <IonButton>Create new role</IonButton>
          </>)}
          </IonContent>
        </IonModal>
    </>
  );
}

export default NewRole;
